export default __webpack_public_path__ + "static/media/university.c50a8d27.png";